module.exports = __webpack_public_path__ + "img/corona.78deb50f.png";